import moment from "moment";
import "moment-timezone";

export const columns = [
  { accessorKey: "serialNumber", header: "Serial #", size: 150 },
  { accessorKey: "registrationNumber", header: "Vehicle", size: 140 },

  { accessorKey: "vehicleStatus", header: "Status", size: 130 },
  { accessorKey: "terminalLocation", header: "Location", size: 150 },
  {
    accessorKey: "weight",
    header: "Vehicle Weight",
    sortable: true,
    size: 200,
  },
  {
    accessorKey: "totalWeight",
    header: "Total Weight",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "netWeight",
    header: "Net Weight",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "cargoTypeName",
    header: "Cargo",
    sortable: true,
    size: 130,
  },
  {
    accessorKey: "consignmentTypeName",
    header: "Consignment",
    sortable: true,
    size: 180,
  },
  {
    accessorKey: "startTime",
    header: "Performed",
    sortable: true,
    size: 160,
    accessorFn: function customCell(row: any) {
      return `${row.startTime ? moment(row.startTime).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
  // {
  //   accessorKey: "endTime",
  //   header: "End Time",
  //   sortable: true,
  //   size: 175,
  //   accessorFn: function customCell(row: any) {
  //     return `${row.endTime ? moment(row.endTime).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
  //   },
  // },
  {
    accessorKey: "vehicleInProgress",
    header: "In Progress ",
    type: "boolean",
    size: 170,
  },
  {
    accessorKey: "refNum",
    header: "Reference #",
    size: 170,
    accessorFn: (row: any) => ` ${row.refNum || " "}`,
  },
  {
    accessorKey: "comment",
    header: "Remarks",
    size: 150,
    accessorFn: (row: any) => ` ${row.comment || " "}`,
  },
  {
    accessorKey: "files",
    header: "Files",
    size: 130,
    accessorFn: (row: any) => ` ${row.files || " "}`,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    size: 300,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
